import { Injectable } from '@angular/core';
import { AssetInScene } from '../models/AssetInScene';
import { TextAsset } from '../models/assets/TextAsset';
import { QuestionAsset } from '../models/assets/QuestionAsset';
import { QuestionSceneAssetRelation } from '../models/scene-asset-relations/QuestionSceneAssetRelation';
import { QuestionSetAsset } from '../models/assets/QuestionSetAsset';

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {

    private textToSpeechApiUrl: string = "https://enetcloud-uk6-test-enetreality-api.azurewebsites.net/api/audio/";
    public staticTextToSpeechUrls: any[] = [];

    constructor() {
        this.initializeStaticUrls();
    }

    initializeStaticUrls(){
    }

    setTextAssetTextToSpeech(assetInScene: AssetInScene) {
      var textAsset = assetInScene.baseAsset as TextAsset;
      var urlToAdd: string = '';
      
      urlToAdd = this.getTextToSpeechSrc(textAsset.text);
      assetInScene.sceneAssetRelation.textToSpeechUrl = urlToAdd;
    }
  
    setQuestionAssetTextToSpeech(assetInScene: AssetInScene) {
      var questionAsset = assetInScene.baseAsset as QuestionAsset;
      var questionSceneAssetRelation = assetInScene.sceneAssetRelation as QuestionSceneAssetRelation;
      var responsesAsText: string = '';
      var questionText: string = '';
      var correctMessageText: string = '';
      var incorrectMessageText: string = '';
      var urlToAdd: string = '';
      questionText = questionAsset.text;
      correctMessageText = questionAsset.correctMessage;
      incorrectMessageText = questionAsset.incorrectMessage;
  
      var i = 1;
      questionAsset.responses.forEach(response => {
        responsesAsText += ' Option ' + i + ': ' + response.text;
        if (!response.text.endsWith('.')) {
          responsesAsText += '.';
        }
  
        i++;
      })
  
      if (!questionText.endsWith('.')) questionText += '.';
  
      urlToAdd = questionText + responsesAsText;
      urlToAdd = this.getTextToSpeechSrc(urlToAdd);
      questionSceneAssetRelation.textToSpeechUrl = urlToAdd;
  
      if(correctMessageText.endsWith('.')) correctMessageText += '.';
      if(incorrectMessageText.endsWith('.')) incorrectMessageText += '.';
      questionSceneAssetRelation.textToSpeechCorrectMessageUrl = this.getTextToSpeechSrc(correctMessageText);
      questionSceneAssetRelation.textToSpeechIncorrectMessageUrl = this.getTextToSpeechSrc(incorrectMessageText);
  
    }
  
    setQuestionSetAssetTextToSpeech(assetInScene: AssetInScene) {
      var questionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
      var description: string = '';
      var title: string = '';
      var urlToAdd: string = '';
      title = questionSetAsset.title;
      description = questionSetAsset.questionSetDescription;
  
      if (!title.endsWith('.')) {
        title += '.';
      }
      if (!description.endsWith('.')) {
        description += '.';
      }
  
      urlToAdd = title + description;
      urlToAdd = this.getTextToSpeechSrc(urlToAdd);
  
      assetInScene.sceneAssetRelation.textToSpeechUrl = urlToAdd;
  
    }

    setQuestionSetTextToSpeechUrl(assetInScene: AssetInScene) {
        var questionSet: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
        var title: string = questionSet.title;
        var description: string = questionSet.questionSetDescription;
        var urlToAdd: string = '';
        if (!title.endsWith('.')) {
            title += '.';
        }
        if (!description.endsWith('.')) {
            description += '.';
        }
        urlToAdd = title + description;
  
        urlToAdd = this.getTextToSpeechSrc(urlToAdd);
        assetInScene.sceneAssetRelation.textToSpeechUrl = urlToAdd;
    }

    getTextToSpeechSrc(textToSpeech: string): string{
      textToSpeech = textToSpeech.replace(/(\r\n|\n|\r)/gm," ");
      textToSpeech = encodeURIComponent(textToSpeech);
      return this.textToSpeechApiUrl + textToSpeech;
    }

}
